export const ADMIN_NAV_GROUPS = [
  {
    id: "analytics",
    label: "Аналитика",
    items: [
      {
        id: "analytics",
        label: "Аналитика",
        description: "Обзор, воронка, выручка и удержание.",
        to: "/admin/analytics"
      },
      {
        id: "stats",
        label: "Статистика",
        description: "Регистрации, выручка и снимок роста.",
        to: "/admin/stats"
      },
      {
        id: "subscriptions",
        label: "Подписки",
        description: "Активные подписки, автопродления и сводка Payment Core.",
        to: "/admin/subscriptions"
      }
    ]
  },
  {
    id: "engagement",
    label: "Коммуникации",
    items: [
      {
        id: "triggers",
        label: "Триггеры",
        description: "Автоматизации жизненного цикла и возврата.",
        to: "/admin/triggers"
      },
      {
        id: "trigger-records",
        label: "Триггеры (БД)",
        description: "Сырые записи bot_triggers: kind/ref_id/data.",
        to: "/admin/trigger-records"
      },
      {
        id: "campaigns",
        label: "Рассылки",
        description: "Массовые сообщения и контроль доставки.",
        to: "/admin/campaigns"
      }
    ]
  },
  {
    id: "content",
    label: "Контент",
    items: [
      {
        id: "locales",
        label: "Локали",
        description: "Переводы, тексты и управление копирайтом.",
        to: "/admin/locales"
      },
      {
        id: "roulette",
        label: "Рулетка",
        description: "Пулы призов, веса и награды.",
        to: "/admin/roulette"
      },
      {
        id: "photosession",
        label: "Фотосессия",
        description: "AI-стили и превью-материалы.",
        to: "/admin/photosession"
      },
      {
        id: "photo-animation",
        label: "Оживить фото",
        description: "AI-видео-стили и attachment-превью.",
        to: "/admin/photo-animation"
      },
      {
        id: "templates",
        label: "Шаблоны",
        description: "Промпты, порядок карточек и видимость.",
        to: "/admin/templates"
      },
      {
        id: "offers",
        label: "AI офферы",
        description: "Recommendation engine: офферы, embeddings и ранжирование.",
        to: "/admin/offers"
      },
      {
        id: "promo-codes",
        label: "Промокоды",
        description: "Создание многоразовых кодов и подписок на срок.",
        to: "/admin/promo-codes"
      }
    ]
  },
  {
    id: "users",
    label: "Пользователи",
    items: [
      {
        id: "users",
        label: "Пользователи",
        description: "Поиск аккаунтов и ручные действия.",
        to: "/admin/users"
      },
      {
        id: "logs",
        label: "Логи",
        description: "История запросов GPT и активность.",
        to: "/admin/logs"
      }
    ]
  }
];

export function getAdminNavItems() {
  return ADMIN_NAV_GROUPS.flatMap((group) => group.items);
}

export function getAdminNavItemByPath(pathname) {
  const items = getAdminNavItems().sort((a, b) => b.to.length - a.to.length);
  return items.find((item) => pathname === item.to || pathname.startsWith(`${item.to}/`)) || items[0];
}
